import type { Child } from "@/vue/entities/face-sheet";

const NICKNAME_NOTICE = "※ニックネームの可能性がある子です";

// 氏名にニックネームの可能性がある場合は注意書きを付与して表示する。
export function formatChildName(child: Pick<Child, "nameKana" | "possiblyNickname">): string {
  const name = child.nameKana || "";
  if (child.possiblyNickname) {
    return `${name} (${NICKNAME_NOTICE})`;
  }
  return name;
}
